module.exports = __webpack_public_path__ + "img/guizhou.9dbdf416.png";